module.exports = __webpack_public_path__ + "static/media/info.bfba029e.svg";